import config from "../app-config";

// LOCATIONS
export const fetch_all_locations = async (booking_only = false) => {
    let endpoint = `${config.endpoint}/locations${booking_only ? "?booking_only=1" : ""}`;
    let response = await fetch(endpoint, { credentials: "include" });
    let data = await response.json();
    return data;
};

export const fetch_location_by_id = async (location_id) => {
    let endpoint = `${config.endpoint}/locations/id/${location_id}`;
    let response = await fetch(endpoint, { credentials: "include" });
    let data = await response.json();
    return data;
};

export const create_location = async (payload) => {
    let endpoint = `${config.endpoint}/locations`;
    let response = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(payload),
    });
    let data = await response.json();
    return data;
};

export const update_location = async (location_id, payload) => {
    let endpoint = `${config.endpoint}/locations/id/${location_id}`;
    let response = await fetch(endpoint, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(payload),
    });
    let data = await response.json();
    return data;
};

export const delete_location = async (location_id) => {
    let endpoint = `${config.endpoint}/locations/id/${location_id}`;
    let response = await fetch(endpoint, {
        method: "DELETE",
        credentials: "include",
    });
    let data = await response.json();
    return data;
};

// BOOKINGS
export const fetch_all_bookings = async (params = {}) => {
    const query = new URLSearchParams(params).toString();
    let endpoint = `${config.endpoint}/locations/bookings?${query}`;
    let response = await fetch(endpoint, { credentials: "include" });
    let data = await response.json();
    return data;
};

export const fetch_booking_by_id = async (booking_id) => {
    let endpoint = `${config.endpoint}/locations/bookings/id/${booking_id}`;
    let response = await fetch(endpoint, { credentials: "include" });
    let data = await response.json();
    return data;
};

export const create_booking = async (payload) => {
    let endpoint = `${config.endpoint}/locations/bookings`;
    let response = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(payload),
    });
    let data = await response.json();
    return data;
};

export const approve_booking = async (booking_id) => {
    let endpoint = `${config.endpoint}/locations/bookings/approve/id/${booking_id}`;
    let response = await fetch(endpoint, {
        method: "PUT",
        credentials: "include",
    });
    let data = await response.json();
    return data;
};

export const reject_booking = async (booking_id, rejection_reason = "") => {
    let endpoint = `${config.endpoint}/locations/bookings/reject/id/${booking_id}`;
    let response = await fetch(endpoint, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ rejection_reason }),
    });
    let data = await response.json();
    return data;
};

export const cancel_booking = async (booking_id) => {
    let endpoint = `${config.endpoint}/locations/bookings/cancel/id/${booking_id}`;
    let response = await fetch(endpoint, {
        method: "PUT",
        credentials: "include",
    });
    let data = await response.json();
    return data;
};

// MAINTENANCE REPORTS
export const fetch_all_reports = async (params = {}) => {
    const query = new URLSearchParams(params).toString();
    let endpoint = `${config.endpoint}/locations/reports?${query}`;
    let response = await fetch(endpoint, { credentials: "include" });
    let data = await response.json();
    return data;
};

export const fetch_report_by_id = async (report_id) => {
    let endpoint = `${config.endpoint}/locations/reports/id/${report_id}`;
    let response = await fetch(endpoint, { credentials: "include" });
    let data = await response.json();
    return data;
};

export const create_report = async (payload) => {
    let endpoint = `${config.endpoint}/locations/reports`;
    let response = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(payload),
    });
    let data = await response.json();
    return data;
};

export const update_report = async (report_id, payload) => {
    let endpoint = `${config.endpoint}/locations/reports/id/${report_id}`;
    let response = await fetch(endpoint, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(payload),
    });
    let data = await response.json();
    return data;
};

export const delete_report = async (report_id) => {
    let endpoint = `${config.endpoint}/locations/reports/id/${report_id}`;
    let response = await fetch(endpoint, {
        method: "DELETE",
        credentials: "include",
    });
    let data = await response.json();
    return data;
};

// CSV BULK UPLOAD
export const upload_locations_csv = async (csv_text) => {
    let endpoint = `${config.endpoint}/locations/upload-csv`;
    let response = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ csv_text }),
    });
    let data = await response.json();
    return data;
};

export const upload_bookings_csv = async (csv_text) => {
    let endpoint = `${config.endpoint}/locations/bookings/upload-csv`;
    let response = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ csv_text }),
    });
    let data = await response.json();
    return data;
};

